module.exports = __webpack_public_path__ + "c_static/img/loading.69a70c7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/loading.gif
// module id = WvZe
// module chunks = 33